import { render, staticRenderFns } from "./buxiugangDialog.vue?vue&type=template&id=6784ec54&scoped=true"
import script from "./buxiugangDialog.vue?vue&type=script&lang=js"
export * from "./buxiugangDialog.vue?vue&type=script&lang=js"
import style0 from "./buxiugangDialog.vue?vue&type=style&index=0&id=6784ec54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784ec54",
  null
  
)

export default component.exports